import { render, staticRenderFns } from "./EmptyBox.vue?vue&type=template&id=bd2c9c7c"
import script from "./EmptyBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports